import { render, staticRenderFns } from "./MatterFinalizationForm.vue?vue&type=template&id=14b8987b&"
import script from "./MatterFinalizationForm.vue?vue&type=script&lang=js&"
export * from "./MatterFinalizationForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterFinalizationForm.vue?vue&type=style&index=0&id=14b8987b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports